import { BoxProps, Center, Spinner, Text } from "@chakra-ui/react";
import React from "react";
import { useBoolean, useTimeout } from "usehooks-ts";

export interface LoadingStateProps extends BoxProps {
  delay?: number;
  message?: string;
  size?: string;
  gap?: number;
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  delay = 500,
  message,
  size,
  gap,
  ...props
}) => {
  const { setTrue: showSpinner, value: isShowingSpinner } = useBoolean();
  useTimeout(showSpinner, delay);

  return (
    <Center
      flex={1}
      gap={gap || 8}
      flexDirection="column"
      data-ls-enabled={true}
      data-public={true}
      py="24px"
      my="24px"
      {...props}
    >
      {isShowingSpinner && (
        <>
          <Spinner size={size} />
          {message && <Text>{message}</Text>}
        </>
      )}
    </Center>
  );
};
